import styled, { css } from "styled-components"
import { BasicInput } from "../elements"

export const Select = styled.select<{ hasError?: boolean }>`
  width: 100%;
  ${BasicInput};
  background: #fff
    url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%23341C4E' stroke-width='1.5'/%3E%3C/svg%3E%0A")
    no-repeat 95% 55%;
  background-size: 0.75rem;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  line-height: 2.5rem;
  cursor: pointer;
  position: relative;
  ${(p) =>
    p.hasError &&
    css`
      border-color: ${p.theme.colors.red.border};
    `};
`
